/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useContext, useEffect, useState } from 'react';
import FilieraContext from '../../contexts/filieraContext';
import { useAccount, useMsal } from '@azure/msal-react';
import { PermissionsApi } from '../../data/apis/PermissionsApi';
import { apiConfiguration } from '../../apiConfig';
import { LoadPanel } from 'devextreme-react/load-panel';

export default function StatistichePage() {

  const { currentFiliera } = useContext(FilieraContext);
  const [link, setLink] = useState<string>('');
  const [loading, setLoading] = useState(true);

  const { accounts } = useMsal();
  const account = useAccount(accounts[0] || {});

  useEffect(() => {
    const fetchPermissions = async () => {
      if (!account?.username) {
        setLoading(false);
        return;
      }

      try {
        const api = new PermissionsApi(apiConfiguration);

        // 🔍 Permessi BI
        const perms = await api.getFilierePermissions();

        // 🔍 Controllo permesso
        const exists = perms.some(p =>
          p.filieraPermissionId === "Filiera/BI/Statistiche"
        );

        if (exists) {
          setLink(
            "https://app.powerbi.com/reportEmbed?reportId=01965474-5f50-4e24-8f2f-340996808375&autoAuth=true&ctid=9a6bb95e-2985-4dfd-b3bf-18638a129013"
          );
        } else {
          setLink("");
        }

      } catch (error) {
        console.error("Errore permission API:", error);
        setLink("");
      }

      setLoading(false);
    };

    fetchPermissions();
  }, [account]);

  if (loading) {
    return <LoadPanel visible={true} position={{ of: '.content' }} />;
  }

  return (
    <React.Fragment>
      {link !== "" &&
        <iframe
          src={link}
          style={{
            display: "block",
            background: "#000",
            border: "none",
            height: "85vh",
            width: "100%"
          }}
          allowFullScreen
        ></iframe>
      }

      {link === "" &&
        <label>Non hai accesso a questo report</label>
      }
    </React.Fragment>
  );
}
